// src/utils/excelUtils.js
import * as XLSX from 'xlsx';

// Column mapping: English key → Hindi header (matching original file)
export const COLUMN_MAP = {
  srNo:         'क्रम संख्या',
  dateOfEntry:  'आवक की दिनांक',
  tagNumber:    'टैग क्रमांक',
  tagColor:     'टैग का रंग',
  breed:        'नस्ल',
  age:          'आयु',
  gender:       'नर/मादा',
  color:        'गौवंश का रंग',
  identifier:   'पहचान का चिन्ह',
  disability:   'अंधा/विकलांग/बीमार',
  dateOfExit:   'निकास की दिनांक',
  exitReason:   'कारण',
};

export function parseExcel(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const raw = XLSX.utils.sheet_to_json(ws, { defval: '' });
        const records = raw.map((row, i) => ({
          srNo:        row[COLUMN_MAP.srNo] || i + 1,
          dateOfEntry: row[COLUMN_MAP.dateOfEntry] || '',
          tagNumber:   String(row[COLUMN_MAP.tagNumber] || ''),
          tagColor:    row[COLUMN_MAP.tagColor] || '',
          breed:       row[COLUMN_MAP.breed] || '',
          age:         Number(row[COLUMN_MAP.age]) || 0,
          gender:      row[COLUMN_MAP.gender] || '',
          color:       row[COLUMN_MAP.color] || '',
          identifier:  row[COLUMN_MAP.identifier] || '',
          disability:  row[COLUMN_MAP.disability] || '',
          dateOfExit:  row[COLUMN_MAP.dateOfExit] || '',
          exitReason:  row[COLUMN_MAP.exitReason] || '',
        }));
        resolve(records);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

export function exportToExcel(records) {
  const data = records.map((r, i) => ({
    [COLUMN_MAP.srNo]:        i + 1,
    [COLUMN_MAP.dateOfEntry]: r.dateOfEntry,
    [COLUMN_MAP.tagNumber]:   r.tagNumber,
    [COLUMN_MAP.tagColor]:    r.tagColor,
    [COLUMN_MAP.breed]:       r.breed,
    [COLUMN_MAP.age]:         r.age,
    [COLUMN_MAP.gender]:      r.gender,
    [COLUMN_MAP.color]:       r.color,
    [COLUMN_MAP.identifier]:  r.identifier,
    [COLUMN_MAP.disability]:  r.disability,
    [COLUMN_MAP.dateOfExit]:  r.dateOfExit,
    [COLUMN_MAP.exitReason]:  r.exitReason,
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  // Column widths
  ws['!cols'] = [
    { wch: 8 }, { wch: 14 }, { wch: 16 }, { wch: 12 }, { wch: 14 },
    { wch: 6 }, { wch: 10 }, { wch: 18 }, { wch: 16 }, { wch: 20 },
    { wch: 14 }, { wch: 12 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Gaushala_Tagg_info');
  XLSX.writeFile(wb, `gaushala_export_${new Date().toISOString().slice(0,10)}.xlsx`);
}

export function getCattleStats(records) {
  const alive = records.filter(r => !r.dateOfExit || r.dateOfExit === '');
  const exited = records.filter(r => r.dateOfExit && r.dateOfExit !== '');

  const bigMale   = alive.filter(r => r.gender === 'MALE'   && r.age > 3).length;
  const smallMale = alive.filter(r => r.gender === 'MALE'   && r.age <= 3).length;
  const bigFemale = alive.filter(r => r.gender === 'FEMALE' && r.age > 3).length;
  const smallFemale = alive.filter(r => r.gender === 'FEMALE' && r.age <= 3).length;

  return { bigMale, smallMale, bigFemale, smallFemale, exited: exited.length, total: records.length };
}
